/**
 * Demo Timer Bar — Zeigt den Countdown oben im App-Bereich an.
 * Wird nur im Demo-Modus sichtbar.
 */
import { useDemo } from "@/contexts/DemoContext";
import { Clock, ExternalLink } from "lucide-react";

export default function DemoTimerBar() {
  const { isDemo, expired, timeDisplay, remainingSeconds } = useDemo();

  if (!isDemo || expired) return null;

  const isUrgent = remainingSeconds < 60;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium transition-colors ${
        isUrgent
          ? "bg-red-600 text-white animate-pulse"
          : "bg-gradient-to-r from-amber-600 to-amber-700 text-white"
      }`}
    >
      <Clock className="h-4 w-4" />
      <span>
        Demo-Modus — Noch <strong>{timeDisplay}</strong> verbleibend
      </span>
      <a
        href="/termin"
        className="ml-2 inline-flex items-center gap-1 rounded-full bg-white/20 px-3 py-0.5 text-xs font-semibold hover:bg-white/30 transition-colors"
      >
        Beratung buchen <ExternalLink className="h-3 w-3" />
      </a>
    </div>
  );
}
